import { CommonService } from 'fccore2';
import {FcEvent} from "./fcevent.event";
import { FCEVENT } from "../fc";

export class FcnavtabBusiness{
    /**
     * ç»ä»¶çåå§åæä½ï¼è®¢éèåéä¸­ï¼è®¢éèåæ¸é¤
     * @param pthis ç»ä»¶å¯¹è±¡çthis
     * @param context åæ°åå®¹
     */
    static fcnavtabInit(pthis:any,context:any):void{
        pthis.pushDestroy(CommonService.subscribe(FcEvent.fcnavtab.fcnavtabClearTabs, (event: FCEVENT) => {
            if (event) {
                pthis.fcTabs=[
                    {
                        enabled: 'Y',
                        disable: 'Y',
                        close: 'N',
                        index: 0,
                        data: {
                            ID: '0',
                            MENUID: '0',
                            MENUICON: 'fc-icon-home',
                            MENUNAME: 'ä¸»é¡µ',
                            MENUTYPE: 'APP',
                            PID: '',
                            ROUTER: 'home'
                        },
                    }
                ]
            }
        }));
    }
    /**
     * æ¸é¤tabé¡µé¢çéé¡¹åå®¹ï¼å¹¶è·³è½¬è³é¦é¡µ
     * @param pthis ç»ä»¶å¯¹è±¡çthis
     * @param context åæ°
     */
    static fcnavtabClearTabs(pthis:any,context:any):void{
       
    }
    
}